import { useEffect } from 'react';
import CommonHeader from '@/components/feature/CommonHeader';
import FirstView from './components/FirstView';
import CommonConcerns from './components/CommonConcerns';
import OurPosition from './components/OurPosition';
import OurPlace from './components/OurPlace';
import ProcessSteps from './components/ProcessSteps';
import CaseStudies from './components/CaseStudies';
import Suitability from './components/Suitability';
import TreatmentOrder from './components/TreatmentOrder';
import WhiteningConnection from './components/WhiteningConnection';
import DoctorMessage from './components/DoctorMessage';
import FinalMessage from './components/FinalMessage';
import CommonFooter from '@/components/feature/CommonFooter';
import FloatingCta from '@/components/feature/FloatingCta';
import MobileBottomNav from '@/components/feature/MobileBottomNav';
import SeoHead from '@/components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/`,
    url: `${siteUrl}/`,
    name: '札幌マウスピース矯正相談 moyuk SAPPORO｜判断するための場所',
    description: 'moyuk SAPPOROは札幌中心部のマウスピース矯正相談クリニック。無理に治療を勧めず、納得いくまで考えていただく時間を大切にします。',
    inLanguage: 'ja',
    isPartOf: { '@id': `${siteUrl}/#website` },
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="マウスピース矯正・ホワイトニング 札幌 | moyuk SAPPORO さいわいデンタル"
        description="札幌・チカホ直結のmoyuk SAPPOROにある矯正歯科。マウスピース矯正の無料診断レポートを提供。「治療を急かさない」医療で、あなたが納得して判断できる環境を整えています。完全個室カウンセリング。"
        keywords="マウスピース矯正 札幌,歯科矯正 札幌,ホワイトニング 札幌,無料矯正相談 札幌,インビザライン 札幌,moyuk SAPPORO,さいわいデンタル,チカホ 歯科"
        canonical={`${siteUrl}/`}
        ogTitle="マウスピース矯正・ホワイトニング 札幌 | moyuk SAPPORO さいわいデンタル"
        ogDescription="札幌・チカホ直結のmoyuk SAPPOROにある矯正歯科。マウスピース矯正の無料診断レポートを提供。納得して判断できる環境で、あなたに合う矯正方法を一緒に整理します。"
        ogSiteName="moyuk SAPPORO さいわいデンタル"
        ogLocale="ja_JP"
        ogImageWidth="1200"
        ogImageHeight="630"
        twitterCard="summary_large_image"
        twitterTitle="マウスピース矯正・ホワイトニング 札幌 | moyuk SAPPORO さいわいデンタル"
        twitterDescription="札幌・チカホ直結。マウスピース矯正の無料診断レポートを提供。治療を急かさない、判断できる矯正歯科。"
        jsonLd={homeJsonLd}
      />
      <CommonHeader />
      <FirstView />
      <CommonConcerns />
      <OurPosition />
      <OurPlace />
      <ProcessSteps />
      <CaseStudies />
      <Suitability />
      <TreatmentOrder />
      <WhiteningConnection />
      <DoctorMessage />
      <FinalMessage />
      <CommonFooter />
      <FloatingCta href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb" label="無料診断を予約する" />
      <MobileBottomNav />
    </div>
  );
}
